<div tabindex="0" class="me-payment-loading" *ngIf="data">
    <div class="spinner-wrapper">
        <div class="spinner">
            <div class="spinner__loading"><i></i><i></i></div>
        </div>
    </div>
    <div class="me-payment-loading__header">
        {{data.title}}
    </div>
    <div class="me-payment-loading__description" [innerHTML]="data.text | storyblokRichtext">
    </div>
</div>